export const ACTIVITY_EFFECTIVENESS_SEGMENTS = {
  general: {
    label: 'General',
    title: 'Efectividad de atenciones',
    heroTitle: 'Efectividad de clientes atendidos',
    formula: 'Clientes únicos en ruta con actividades registradas / Meta clientes en el periodo'
  },
  order: {
    label: 'Pedido',
    title: 'Efectividad de venta',
    heroTitle: 'Efectividad de venta',
    formula: 'Clientes únicos en ruta con pedido registrado / Meta clientes en el periodo'
  },
  charge: {
    label: 'Cobro',
    title: 'Efectividad de cobro',
    heroTitle: 'Efectividad de cobro',
    formula: 'Clientes únicos en ruta con cobro registrado / Meta clientes en el periodo'
  },
  delivery: {
    label: 'Entrega',
    title: 'Efectividad de entrega',
    heroTitle: 'Efectividad de entrega',
    formula: 'Clientes únicos en ruta con entrega registrada / Meta clientes en el periodo'
  }
}
